import { LdEnvironmentType, StatsigEnvironment } from '@atlassian/mpac-feature-flags';
const localConfig = {
  feedbackCollectorApiKeys: {
    privacyAndSecurity: {
      entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
    },
    generalFeedback: {
      entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
    }
  },
  stargateBaseUrl: 'https://api.stg.atlassian.com',
  adminHubBaseUrl: 'https://admin.stg.atlassian.com',
  algolia: {
    applicationId: '7LVR1JKTDF',
    apiKey: '15f50298dd61ef869dcbf0db33add5fd',
    environment: 'stg'
  },
  sentry: {
    dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
    environment: 'local'
  },
  analytics: {
    productAnalytics: {
      env: 'local'
    }
  },
  host: '',
  featureFlags: {
    apiKey: '455fa60a-debf-4a78-8ec0-7fef7a97ae70',
    environment: LdEnvironmentType.DEV
  },
  statsig: {
    // confluence dev -- 1a9e352b-a0c4-4678-8f09-6a43d1e2b0cc
    // jira dev -- 8da3f751-e5a7-4a9c-8d33-425bf098fbe8
    // compass dev -- a78a83e2-f9e2-46e6-8ac9-046360f8a1ba
    clientKey: '8da3f751-e5a7-4a9c-8d33-425bf098fbe8',
    environment: StatsigEnvironment.Development,
    targetApp: 'jira_web' // options are jira_web, confluence_web, compass_web
  },
  mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
  mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
  showDevtools: true,
  metal: {
    id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
    env: 'local'
  },
  graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
  atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
  macBaseUrl: 'https://my.stg.internal.atlassian.com',
  wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
  environment: 'local'
};
export default localConfig;